import { CoffeeIcon, LeftArrowIcon } from '@insta-club/components';
import { t } from '@insta-club/translations';
import { cn } from '@insta-club/utilities';

type Status = 'progress' | 'done' | 'notDone';

interface Props {
    title: string;
    status: Status;
    disabled?: boolean;
    description: string;
    onClick?: () => void;
}

const ProgramCategory: React.FC<Props> = ({ title, description, status, onClick, disabled }) => {
    return (
        <div
            onClick={disabled ? undefined : onClick}
            className={cn('flex cursor-pointer flex-col gap-1 rounded-xl bg-gray-100 p-4', {
                'bg-success-50': status === 'done',
                'cursor-not-allowed bg-gray-50': disabled
            })}
        >
            <div className='flex items-center gap-2'>
                <div className='flex flex-1 items-center gap-2'>
                    <p className='text-primary-900 text-base font-bold'>{title}</p>
                    {disabled && <CoffeeIcon width={20} className='text-success-500 mb-0.5' />}
                    {status === 'done' && (
                        <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
                            <path
                                d='M14.19 0H5.81C2.17 0 0 2.17 0 5.81V14.18C0 17.83 2.17 20 5.81 20H14.18C17.82 20 19.99 17.83 19.99 14.19V5.81C20 2.17 17.83 0 14.19 0ZM14.78 7.7L9.11 13.37C8.97 13.51 8.78 13.59 8.58 13.59C8.38 13.59 8.19 13.51 8.05 13.37L5.22 10.54C4.93 10.25 4.93 9.77 5.22 9.48C5.51 9.19 5.99 9.19 6.28 9.48L8.58 11.78L13.72 6.64C14.01 6.35 14.49 6.35 14.78 6.64C15.07 6.93 15.07 7.4 14.78 7.7Z'
                                fill='#009A3F'
                            />
                        </svg>
                    )}
                </div>
                {!disabled ? (
                    <div className='flex items-center gap-2 text-gray-600'>
                        <span className='relative top-[1px] text-sm'>{t('details')}</span>
                        <LeftArrowIcon width={5} height={10} />
                    </div>
                ) : null}
            </div>
            <span className='text-sm text-gray-600'>
                {/* {disabled ? `در این روز ☕ هیچ برنامه ${title} ندارید` : description} */}
                {description}
            </span>
        </div>
    );
};

export default ProgramCategory;

